/**
 * This utility class permits the abstraction of methods
 * for reuse
 */
import imagemapjson from "../../components/static/imagemap.json";
import { config } from "../../config/env";

const imagemap = new Map(Object.entries(imagemapjson));

/**
   *
   * @param {The type of the enum - like GENDER or PARTY} enumType 
   * @param {The Key to the enum you are looking-up} entryKey
   * @returns The usable path and filename of the image found or <undefined>
   */
export default function getCharacteristicsImagePath(enumType,entryKey) {
    let useablePath;
    try {
      const mapOfCharacteristics = new Map(
        Object.entries(imagemap.get(enumType))
      );
      const relativePath = mapOfCharacteristics.get(entryKey);
      useablePath = config.publicUrl + relativePath;
    } catch {}
    return useablePath;
  }

  /**
   * 
   * @param {The type of the enum - like GENDER or PARTY} enumType 
   * @param {The Key to the enum you are looking-up} entryKey
   * @returns Boolean
   */
  export function imagePathValid(enumType,entryKey){
    const path = getCharacteristicsImagePath(enumType,entryKey);
    const b  = path !== 'undefined';
    return b;
  }

  /**
   * 
   * @param {A url String} url 
   * @returns Boolean 
   * if url is valid construct but does not check existance
   */
  export function validUrl(url) {
    return /http(s)?:\/\/(\w+:?\w*@)?(\S+)(:\d+)?((?<=\.)\w+)+(\/([\w#!:.?+=&%@!\-/])*)?/gi.test(url);
  }
  
  